{
	"accounts": "Accounts",
	"addAccount": "Add Account",
	"exportExcel": "Export to excel",
	"importExcel": "Import to excel",
	"payable": "Payable",
	"receivable": "Receivable",
	"emptyText": "No account found",
	"isPaidYes": "Yes",
	"isPaidNo": "No",
	"buttonActions": {
		"markAsPaid": "Mark as paid",
		"unMarkAsPaid": "Unmark as paid",
		"markAsReceived": "Mark as received",
		"unMarkAsReceived": "Unmark as received",
		"viewDetails": "View details",
		"viewEdit": "View/Edit"
	},
	"clearAllFilters": "Clear all filters",
	"clearAllFiltersTooltip": "Remove all applied filters and return to default view",
	"status": {
		"all": "All",
		"payabled": "Paid",
		"recivabled": "Received",
		"late": "Late",
		"conciliated": "Conciliated",
		"payablePending": "Pending Payment",
		"receivablePending": "Pending Receipt",
		"payableToday": "Pay Today",
		"receivableToday": "Receive Today"
	},
	"titleAccountPayable": "Accounts payable",
	"excelFileNamePayable": "accounts_to_pay",
	"titleAccountReceivable": "Accounts receivable",
	"excelFileNameReceivable": "accounts_to_received",
	"form": {
		"newAccountPayable": "New account payable",
		"editAccountPayable": "Edit account payable",
		"newAccountReceivable": "New account receivable",
		"editAccountReceivable": "Edit account receivable",
		"informOfPayments": "Payment information",
		"postingInformation": "Posting Information",
		"lblSupplier": "Supplier",
		"phSupplier": "Select Supplier",
		"lblDocNumber": "Document number",
		"phDocNumber": "Insert Document Number",
		"lblInvoiceDate": "Accrual Date",
		"phInvoiceDate": "Select Accrual Date",
		"lblPaymentDate": "Payment date",
		"phPaymentDate": "Select Payment Date",
		"lblDueDate": "Due Date",
		"phDueDate": "Select Due Date",
		"lblDescription": "Description",
		"phDescription": "Insert Description",
		"phValue": "Insert Value",
		"lblValue": "Value",
		"lblPaymentMethod": "Payment Method",
		"phPaymentMethod": "Select Payment Method",
		"lblAccountId": "Bank account",
		"phAccountId": "Select Bank Account",
		"lblCostCenter": "Cost Center",
		"phCostCenter": "Select Cost Center",
		"lblChartAccounts": "Chart of Accounts",
		"phChartAccounts": "Select Chart of Accounts",
		"ttRequiredWhenFilled": "When filling in the value field, the chart of accounts becomes mandatory.",
		"lblInterest": "Interest on arrears",
		"phInterest": "Select Interest on arrears",
		"lblFine": "Delay fine",
		"phFine": "Select Late Fee",
		"lblDiscount": "Discounts",
		"phDiscount": "Select Discounts",
		"lblPaidValue": "Amount paid",
		"phPaidValue": "Select Paid Value",
		"phZeroValue": "0.00",
		"swtIsPaid": "Paid",
		"swtConciliated": "Reconciled",
		"swtTotalValue": "Total value:",
		"recurringPayment": "Recurring payment",
		"lblRecurringPaymentInterval": "Repeat every",
		"phRecurringPaymentInterval": "Enter interval",
		"oneTime": "One-time value",
		"recurring": "Recurring value",
		"installment": "Installment value",
		"lblInstallmentCount": "Number of installments",
		"phInstallmentCount": "Enter the number of installments",
		"lblInstallmentInterval": "Repeat every",
		"phInstallmentInterval": "Enter the interval",
		"lblInstallmentTypeInterval": "Interval",
		"phInstallmentTypeInterval": "Select the interval type",
		"installmentSummary": "Total value of {{total}} split into {{count}} installments",
		"lblInstallmentBetween": "Interval between installments",
		"phInstallmentBetween": "Select the interval",
		"lblInstallmentFirstDueDate": "First installment due date",
		"lblInstallmentFirstCompetenceDate": "First installment accrual date",
		"installmentPeriodicity": {
			"Day": "Daily",
			"Week": "Weekly",
			"Month": "Monthly",
			"Year": "Yearly"
		},
		"lblRecurringPaymentTypeInterval": "Interval",
		"phRecurringPaymentTypeInterval": "Select interval type",
		"lblRecurringPaymentTimes": "How many times?",
		"phRecurringPaymentTimes": "Enter number of times",
		"totalRepetition": "Total in ",
		"recurringEnd": "End of recurrence:",
		"observation": "Observation",
		"attachment": "Attachment",
		"lblObservation": "Insert observation",
		"lblAttachment": "Click or drag to attach files",
		"lblFinancialFees": "Financial Fees",
		"phFinancialFees": "Select Financial Fees",
		"validations": {
			"dueDate": "Enter Due Date to continue",
			"value": "Enter Value to continue",
			"chartAccounts": "Select Chart of Accounts to continue",
			"discountGreaterThanBill": "Discount cannot be greater than the account value",
			"recurringPaymentInterval": "Enter recurring payment interval",
			"recurringPaymentTypeInterval": "Select recurring payment type interval",
			"recurringPaymentTimes": "Enter number of recurring payment times",
			"recurringPaymentTimesMax": "The maximum number of recurrences allowed is 48",
			"installmentCount": "Enter the number of installments (minimum 2)",
			"installmentCountMax": "The maximum number of installments allowed is 48",
			"installmentInterval": "Enter the interval between installments",
			"installmentTypeInterval": "Select the interval type",
			"paymentDate": "Enter the payment date to continue"
		},
		"modalDelete": {
			"title": "Delete account",
			"cancelText": "Cancel",
			"okText": "Delete account",
			"message": "Account deletion is a final action. Do you want to proceed with deletion?"
		}
	},
	"columns": {
		"docNumber": "DOCUMENT NUMBER",
		"supplier": "SUPPLIER",
		"chartOfAccount": "CHART OF ACCOUNTS",
		"account": "RECEIPT ACCOUNT",
		"invoiceDate": "EXPIRATION DATE",
		"dueDate": "COMPETENCY DATE",
		"paymentDate": "PAYMENT DATE",
		"value": "VALUE",
		"situation": "SITUATION",
		"paymentMethod": "PAYMENT METHOD",
		"actions": "ACTIONS"
	},
	"attachModal": {
		"title": "Account Attachments",
		"noAttachments": "No attachments found at this time",
		"table": {
			"columns": {
				"attachedFiles": "Attached files"
			},
			"successfullyDeletedFile": "File deleted",
			"errorDeleted": "Unable to delete file"
		}
	},
	"chartAccounts": "Chart of accounts",
	"placeholderChartAccounts": "Select chart of accounts",
	"labelFilter": "Click to filter",
	"selectSupplier": "Filter by supplier",
	"lblDocNumber": "Filter by document number",
	"phDocNumber": "Enter the number to filter",
	"lblPaymentDate": "Filter by payment date",
	"lblPaymentStatus": "Filter by payment status",
	"optPaymentStatusAll": "All",
	"optPaymentStatusPaid": "Paid",
	"optPaymentStatusNotPaid": "Not Paid",
	"optReceivabledStatus": "Received",
	"optNotReceivabledStatus": "Not Received",
	"lblDueDate": "Filter by due date",
	"lblInvoiceDate": "Filter by accrual date",
	"tzReceived": "Received",
	"tzRecivabledToday": "Receive today",
	"tzmaturing": "Pay today",
	"tzDue": "Due",
	"tzDelayed": "Delayed",
	"tzPaid": "Paid",
	"tzTotal": "Period total",
	"attatchmentDescription": "Attach payment receipts or other documents related to this account so you don't lose track of them. Up to 4 documents are allowed in PDF, OFX, XML, XLS, JPG and PNG formats with up to 1.5MB.",
	"attachFile": "Click to attach a file",
	"attachImportError": {
		"existingFile": "File already imported",
		"exceededSize": "Size limit exceeded. The attachment must not be larger than 1.5MB"
	},
	"attachedToChartAccountsModal": {
		"linksPlural": "{{chartAccounts}} links",
		"linksSingular": "1 link",
		"seeLinks": "See links",
		"title": "Linked Chart of Accounts",
		"description": "Relation of registration with which this item is linked"
	},
	"modalPayment": {
		"title": "Mark as paid",
		"titleReceivable": "Mark as received",
		"paymentMethod": "Payment method",
		"selectPaymentMethod": "Select payment method",
		"interests": "Interests on arrears",
		"fine": "Delay fine",
		"discount": "Discounts",
		"financialFees": "Financial Fees",
		"description": "Select the date the payment was made and which account you want to record the payment in",
		"descriptionReceivable": "Select the date the receipt was made and which account you want to record the receipt in",
		"paymentDate": "Payment date",
		"receiptDate": "Receipt date",
		"paymentAccount": "Payment account",
		"selectAccount": "Select a registered account",
		"required": "Please select a payment date",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"addAccount": "Add account",
		"deletedAccount": "Deleted account",
		"placeholderChartOfAccounts": "Select chart of accounts",
		"placeholderZeroValue": "0,00",
		"errors": {
			"paymentDate": {
				"required": "Payment date is required",
				"invalid": "Invalid date format",
				"future": "Date cannot be later than the entry opening date"
			},
			"paymentAccount": {
				"required": "Payment account is required"
			},
			"requiredChartOfAccounts": "Select a chart of accounts",
			"requiredValue": "Enter the value",
			"discountGreaterThanBill": "The discount cannot be greater than the account value"
		}
	},
	"startDate": "Start date",
	"endDate": "End date",
	"drawer": {
		"titlePayable": "Payable account",
		"titleReceivable": "Receivable account",
		"titlePayableEdit": "Edit payable account",
		"titleReceivableEdit": "Edit receivable account",
		"titlePayableView": "View payable account",
		"titleReceivableView": "View receivable account",
		"tabs": {
			"launch": "Launch",
			"attachments": "Attachments",
			"recurrencesSummary": "Recurrences summary",
			"editHistory": "Edit history",
			"installment": "Installment",
			"installmentPaid": "Launch",
			"installmentSummary": "Total launch summary",
			"installmentSummaryPaid": "Payment summary"
		},
		"sections": {
			"generalInfo": "General information",
			"details": "Details"
		},
		"attachments": {
			"dropTitle": "Drag and drop files here",
			"dropSelect": "or select files",
			"allowedFormats": "Up to 4 documents allowed in PDF, OFX, XML, XLS, JPG and PNG formats up to 1.5MB.",
			"of": "of",
			"filesLabel": "files"
		},
		"markAsPaid": "Paid?",
		"markAsReceived": "Received?",
		"lblReceiptDate": "Receipt date",
		"phReceiptDate": "Select receipt date",
		"errors": {
			"paymentDate": {
				"future": "Date cannot be later than the entry opening date"
			}
		},
		"footer": {
			"totalValue": "Total value:",
			"submit": "Register entry",
			"submitUpdate": "Save changes",
			"badgeAVista": "ONE-TIME",
			"badgeRecorrente": "RECURRING",
			"recurringWillLaunch": "Will launch",
			"recurringRecurrencesOf": "recurrences of",
			"recurringEvery": "every",
			"installmentSplitIn": "split into",
			"installmentTimesEvery": "times every",
			"installmentParcelValue": "Installment value",
			"installmentTotalOf": "Total value of",
			"installmentDividedIn": "divided into",
			"installmentParcelsWord": "installments"
		},
		"tooltips": {
			"recurring": "Automatically create repeated entries at a defined frequency.",
			"installmentNotRecurring": "Installment entries cannot be recurring.",
			"markAsPaid": "Mark the entry as paid and provide the payment details.",
			"markAsReceived": "Mark the entry as received and provide the receipt details."
		},
		"recurrencesSummary": {
			"emptyText": "No recurrences found.",
			"distributionTitle": "Recurrences distribution",
			"columns": {
				"sequence": "Installment",
				"dueDate": "Due date",
				"finalValue": "Final value",
				"status": "Status"
			}
		},
		"installmentSummary": {
			"summaryTitle": "Launch summary",
			"totalValue": "Value",
			"type": "Type",
			"typeInstallment": "Installment value",
			"typeAVista": "Cash value",
			"quitButton": "Settle payment",
			"numberOfInstallments": "Number of installments",
			"firstDueDate": "Due date",
			"interval": "Interval between installments",
			"distributionTitle": "Installments distribution",
			"emptyText": "No installments found.",
			"hasCharges": "Installment with interest, fine or discount",
			"totalizerTotalAmount": "Total value of installments",
			"totalizerInterest": "Total interest paid",
			"totalizerFine": "Total fines paid",
			"totalizerDiscount": "Total discounts obtained",
			"totalizerPaid": "Total paid so far",
			"blockedBanner": "This launch can’t be edited because it already has paid installments."
		},
		"editHistory": {
			"tabLabel": "Edit history",
			"emptyText": "No changes recorded.",
			"installmentTag": "Installment {{number}}/{{total}}",
			"columns": {
				"action": "Action",
				"user": "User",
				"dateTime": "Date and time"
			},
			"user": {
				"system": "System"
			},
			"fields": {
				"valor": "value",
				"juros": "late interest",
				"multa": "late fine",
				"desconto": "discount",
				"taxasAdministrativas": "administrative fees",
				"valorPago": "paid value",
				"valorRecebido": "received value",
				"dataDeVencimento": "due date",
				"dataDeCompetencia": "invoice date",
				"dataDePagamento": "payment date",
				"dataDeRecebimento": "receipt date",
				"formaDePagamento": "payment method",
				"formaDeRecebimento": "receipt method",
				"contaBancaria": "bank account",
				"fornecedor": "supplier",
				"numeroDoDocumento": "document number",
				"descricao": "description",
				"observacao": "observation",
				"statusDePagamento": "payment status",
				"statusDeRecebimento": "receipt status",
				"conciliacao": "reconciliation",
				"planoDeContas": "chart of accounts"
			},
			"badges": {
				"created": "Entry created",
				"paymentAdded": "Marked as paid",
				"paymentAddedReceivable": "Marked as received",
				"reconciled": "Reconciled",
				"deleted": "Entry removed",
				"unknown": "Entry updated"
			},
			"events": {
				"updatedTo": "Changed {{field}} to {{toValue}}"
			}
		},
		"modalDeleteInstallment": {
			"title": "Delete installment entry?",
			"message": "All {{total}} installments will be removed. This action cannot be undone.",
			"messageWithPaid": "All {{total}} installments will be removed, including paid ones — paid entries will be reversed from Cash Flow and the income statement (DRE). This action cannot be undone.",
			"cancelText": "Cancel",
			"okText": "Delete"
		}
	}
}
